import { COUNTRY_CODES } from '../data.js';

type Location = { country?: unknown; countryCode?: unknown } | null | undefined;
type OrganizationLocations = { headquartersAddress?: Location; additionalLocations?: Location[] };

const namesByCode = new Map<string, string>();
const namesByKey = new Map<string, string>();
for (const [name, codes] of Object.entries(COUNTRY_CODES)) {
    namesByKey.set(name.toLowerCase(), name);
    namesByCode.set(codes.iso2.toUpperCase(), name);
    namesByCode.set(codes.iso3.toUpperCase(), name);
}

export function serviceCountryName(value: unknown): string {
    const raw = String(value || '').trim();
    return namesByCode.get(raw.toUpperCase()) || namesByKey.get(raw.toLowerCase()) || raw;
}

export function serviceRequestCountries(organization: OrganizationLocations): string[] {
    const locations = [organization.headquartersAddress, ...(organization.additionalLocations || [])];
    const countries = new Set<string>();
    for (const location of locations) {
        const country = serviceCountryName(location?.country || location?.countryCode);
        if (country)
            countries.add(country);
    }
    return [...countries].sort();
}

export function unavailableServiceCountries(organization: OrganizationLocations, requested: unknown[]): string[] {
    const allowed = new Set(serviceRequestCountries(organization).map(country => country.toLowerCase()));
    return [...new Set(requested.map(serviceCountryName).filter(country => country && !allowed.has(country.toLowerCase())))];
}
